import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import queryString from 'query-string';
import { FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { searchSelector } from 'Store/modules/router/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import { routes } from 'Constants/routes';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import { FRONT_PLANS, parsePlans, PLANS_MODE } from 'Constants/plans';
import { plansLotties } from 'Constants/lottiesPaths';
import { TAX_YEAR } from 'Config';
import * as Styled from './styles';
import { redirectTo, useFetchGetSuccessResult, useSubmitFlex } from './hooks';

const FLEX_TYPE = 'flex';
const FLEX_LITE_TYPE = 'trial';

const SuccessStepView = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.PLANS);
  const planes = useSelector(searchSelector);
  const { mutate } = useSubmitFlex();
  const {
    plans,
    filing: isFilingInfo,
    compensation,
    fromFedUser,
    submitFlex,
    submitFlexLite,
    isExtendedFlexLite,
    isExtendedAndIsToReturn,
    saveCard,
  } = queryString.parse(planes);
  useFetchGetSuccessResult({
    isFiling: Boolean(isFilingInfo),
    plans: plans?.toString(),
    compensation: Boolean(compensation),
    fromFedUser: Boolean(fromFedUser),
    saveCard: Boolean(saveCard),
    isExtendedFlexLite: Boolean(isExtendedFlexLite),
    isExtendedAndIsToReturn: isExtendedAndIsToReturn === 'true',
  });

  useEffect(() => {
    if (!isFilingInfo) {
      redirectTo(routes.DASHBOARD);
    }
  }, [isFilingInfo]);

  useEffect(() => {
    if (submitFlex || submitFlexLite) {
      mutate({
        taxYear: TAX_YEAR.toString(),
        type: submitFlexLite ? FLEX_LITE_TYPE : FLEX_TYPE,
      });
    }
  }, [submitFlex]);

  return (
    <Styled.StyledContainer
      direction="column"
      align="center"
      justify="center"
      fullHeight
      fullWidth
      plan={parsePlans(FRONT_PLANS[plans?.toString() || ''])}
    >
      <Styled.StyledLottie
        options={{
          path: plansLotties[plans?.toString() || ''],
        }}
      />
      <FlexContainer align="center" direction="column" gap="dimension_08">
        <Text type="headline" color="dark" size="XS_L_S">
          {t('Checkout.success.title')}
        </Text>
        <Styled.PlanLogoContainer align="center" gap="dimension_08">
          <img
            src={`${TAXDOWN_ASSETS_DOMAIN}/plans/smart-filter/v2/${PLANS_MODE[parsePlans(FRONT_PLANS[plans?.toString() || ''])]}_logo.svg`}
            alt={`${FRONT_PLANS[plans?.toString() || '']}_logo`}
          />
          <Text type="headline" size="S_L_M" color="dark">
            {parsePlans(FRONT_PLANS[plans?.toString() || ''])}
          </Text>
        </Styled.PlanLogoContainer>
      </FlexContainer>
    </Styled.StyledContainer>
  );
};

export default SuccessStepView;
